import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from '@thinglogix/ngx-foundry-core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'li-forgot-password',
    templateUrl: './forgot-password.component.html',
    styleUrls: ['./forgot-password.component.sass'],
})
export class ForgotPasswordComponent implements OnInit, OnDestroy {
    isLoader = false;

    isLoadingMode = true;

    loginError = '';

    sucessClass = '';

    sucessClassAdd = '';

    forgotForm!: FormGroup;

    private ngUnsubscribe = new Subject();

    constructor(
        private fb: FormBuilder,
        private router: Router,
        private authService: AuthService
    ) {}

    ngOnInit(): void {
        // applying the validation using the form value
        this.forgotForm = this.fb.group({
            account: [environment.liquidInsightAccountId, Validators.required],
            email: ['', [Validators.required, Validators.email]],
        });
    }

    ngOnDestroy(): void {
        this.ngUnsubscribe.next(undefined);
        this.ngUnsubscribe.complete();
    }

    /**
     * Calls the forgot password API using the form value
     *
     * @returns {Promise<void>} Promise with void value after the API has been called
     */
    async forgot(): Promise<void> {
        const account: string = this.forgotForm.value.account;
        const email: string = this.forgotForm.value.email.trim();
        this.isLoader = true;
        this.loginError = '';
        this.authService
            .forgotPassword(email, account)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(
                () => {
                    // Sucess Response
                    this.isLoader = false;
                    this.sucessClass = 'tabcontentRemove';
                    this.sucessClassAdd = 'tabcontentadd';
                },
                (err) => {
                    // Error Response
                    this.isLoader = false;
                    this.loginError = err.error['error'];
                }
            );
    }
}
